import {BookingTypeEnum, FlowEnum} from 'presentation/pages/private/booking/constants';
import {FlowTypeEnumWithoutAuth} from './flowType';

export function getFlowTypeByBookingType(bookingType: BookingTypeEnum) {
	const formatBookingType = bookingType.toLowerCase() as BookingTypeEnum;

	const flowType: Record<BookingTypeEnum, FlowTypeEnumWithoutAuth> = {
		[BookingTypeEnum.HEALTH]: FlowEnum.HEALTH,
		[BookingTypeEnum.TELEHEALTH]: FlowEnum.TELEHEALTH,
		[BookingTypeEnum.ODONTO]: FlowEnum.ODONTO,
		[BookingTypeEnum.EXAM]: FlowEnum.EXAM,
		[BookingTypeEnum.SURGERY]: FlowEnum.SURGERY,
	};

	return flowType[formatBookingType];
}
